export default {
  toasts: {
    verification_pending: 'Uw verificatie is nog in behandeling',
  },
};
